import TrainerSocialLinkedIn from './TrainerSocialLinkedIn';
import TrainerSocialEmail from './TrainerSocialEmail';
import {
  trainerSocialDefaultProps,
  trainerSocialPropTypes,
} from './TrainerSocialShape';

const defaultProps = {
  ...trainerSocialDefaultProps,
};

const propTypes = {
  ...trainerSocialPropTypes,
};

export default function TrainerActions({ email, linkedin }) {
  const hasEmail = email !== null;
  const hasLinkedIn = linkedin !== null;

  return (
    <div className="pt-4 flex -mx-2">
      {hasEmail && (
        <div className="px-2">
          <TrainerSocialEmail email={email} />
        </div>
      )}
      {hasLinkedIn && (
        <div className="px-2">
          <TrainerSocialLinkedIn url={linkedin} />
        </div>
      )}
    </div>
  );
}

TrainerActions.defaultProps = defaultProps;
TrainerActions.propTypes = propTypes;
